import { pluralize } from '@libs/i18n';
import { Badge } from '@ui/components/Badge';

const PLAYER_PLURAL = {
  many: '{number}\u00A0участников',
  few: '{number}\u00A0участника',
  one: '{number}\u00A0участник',
  zero: '{number}\u00A0участников',
};

type Props = {
  tournament?: {
    participantsCount?: number;
  };
};

export function TournamentParticipantsBadge({ tournament }: Props) {
  if (!tournament) return null;

  return (
    <Badge size="m" flat>
      {pluralize(PLAYER_PLURAL, tournament.participantsCount)}
    </Badge>
  );
}
